import { Link, LinkProps, useLocation, useResolvedPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { languages_enum } from "redux/actions/globalSlice";

const supportedLangs = [languages_enum.ENGLISH, languages_enum.RUSSIAN];

export function LocalizedLink({ to, ...rest }: LinkProps) {
  const language = useSelector((state: RootState) => state.global.language);
  const location = useLocation();
  const prefix = language === languages_enum.GEORGIAN ? "" : `/${language}`;
  const resolved = useResolvedPath(to);

  // If already prefixed like "/en", skip
  const firstSegment = resolved.pathname.split("/")[1];
  const alreadyPrefixed = supportedLangs.includes(firstSegment as languages_enum);

  const finalPath = alreadyPrefixed
    ? resolved.pathname
    : `${prefix}${resolved.pathname}`.replace(/\/{2,}/g, "/");

  const newTo =
    typeof to === "string"
      ? finalPath
      : {
          ...to,
          pathname: finalPath,
        };

  return <Link to={newTo} {...rest} />;
}
